<template>
  <!-- 修改手机号 -->
  <el-dialog
    title="信息变更-手机换绑"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content-wrap">
      <el-form label-width="120px" size="medium" :model="form" ref="form">
        <el-form-item label="现有手机号" class="mobile-item">
          <p class="mobile">{{ user && user.mobile ? user.mobile : "" }}</p>
          <el-button type="text" @click="sendCode('old')" :disabled="sending">{{
            buttonText
          }}</el-button>
        </el-form-item>
        <el-form-item label="请输入验证码">
          <el-input v-model.trim="form.old_code" maxlength="6"></el-input>
        </el-form-item>
        <div class="new-mobile-wrap">
          <el-form-item label="新手机号" class="mobile-item">
            <!-- <el-input
              class="mobile"
              v-model.trim="form.new_mobile"
              maxlength="11"
            ></el-input> -->
            <input-phone
              class="mobile"
              maxlength="11"
              :mobile.sync="form.new_mobile"
              :code.sync="form.region_num"
              :code-list="codeList"
            ></input-phone>
            <el-button
              type="text"
              @click="sendCode('new')"
              :disabled="sendingNew"
              >{{ buttonTextNew }}</el-button
            >
          </el-form-item>
          <el-form-item label="请输入验证码">
            <el-input v-model.trim="form.new_code" maxlength="6"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" v-preventReClick
        >提交</el-button
      >
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { vailPhone } from "@saas/components/src/utils/utils.js";
import ManMachineVerify from "@saas/components/src/mixins/manMachineVerify";
import InputPhone from "@saas/components/src/components/input-phone/Index.vue";
import { sendCode } from "@saas/service-api/src/index.js";
import {
  updateMobile,
  checkAccount,
} from "@saas/service-api/src/user-info/index.js";
import { mapGetters } from "vuex";
export default {
  components: {
    InputPhone,
  },
  mixins: [ManMachineVerify],
  data: function () {
    return {
      dialogVisible: false,
      form: {},
      buttonText: "获取验证码",
      buttonTextNew: "获取验证码",
      buttonTimer: null,
      time: 60,
      buttonTimerNew: null,
      timeNew: 60,
      sending: false,
      sendingNew: false,
      codeType: "",
      loading: false,
    };
  },
  mounted() {
    this.$store.dispatch("user/getCountryCode");
  },
  methods: {
    // 设置选中区号
    setSelectRegionNum() {
      if (this.codeList.length) {
        this.codeList.forEach((item) => {
          if (item.is_def === 1) {
            this.form.region_num = item.region_num;
          }
        });
      }
    },
    // 人机验证回调
    captchaCallback(res) {
      try {
        if (res.ret === 0) {
          this.sendVerifyCode(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 发送验证码
    sendVerifyCode(res) {
      let params = {
        randstr: res.randstr,
        scene: "UpdateMobile",
        ticket: res.ticket,
        region_num: this.codeType === "new" ? this.form.region_num : "",
      };
      let type = this.codeType;
      if (type === "new") {
        params.account = this.form.new_mobile;
        this.sendingNew = true;
      } else if (type === "old") {
        params.account = this.user.mobile;
        this.sending = true;
      }
      sendCode(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("验证码已发送");
            if (type === "new") {
              this.timer(
                "buttonTimerNew",
                "buttonTextNew",
                "timeNew",
                "sendingNew"
              );
            } else {
              this.timer();
            }
          } else {
            this.$message.error(res.message);
            if (type === "new") {
              this.sendingNew = false;
            } else {
              this.sending = false;
            }
          }
        })
        .catch(() => {
          if (type === "new") {
            this.sendingNew = false;
          } else {
            this.sending = false;
          }
        });
    },
    timer(
      buttonTimer = "buttonTimer",
      buttonText = "buttonText",
      time = "time",
      sending = "sending"
    ) {
      this[buttonTimer] = setInterval(() => {
        if (this[time] < 1) {
          clearInterval(this[buttonTimer]);
          this[buttonText] = "获取验证码";
          this[sending] = false;
          this[time] = 60;
        } else {
          this[time] = this[time] - 1;
          this[buttonText] = `${this[time]}s后重新发送`;
        }
      }, 1000);
    },
    showDialog() {
      this.dialogVisible = true;
      this.setSelectRegionNum();
    },
    submitForm() {
      if (!this.form.old_code || !this.form.new_code) {
        this.$message.warning("请输入验证码");
        return false;
      }
      if (this.form.new_mobile.length > 11 || this.form.new_mobile.length < 6) {
        this.$message.warning("请输入正确的手机号");
        return false;
      }
      let params = {
        ...this.form,
        old_mobile: this.user.mobile,
      };
      if (this.loading) return;
      this.loading = true;
      updateMobile(params)
        .then((res) => {
          if (res.code === 1) {
            this.handleClose();
            this.$emit("success");
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = {};
      this.buttonText = "获取验证码";
      this.buttonTextNew = "获取验证码";
      if (this.buttonTimer) {
        clearInterval(this.buttonTimer);
        this.buttonTimer = null;
      }
      this.time = 60;
      if (this.buttonTimerNew) {
        clearInterval(this.buttonTimerNew);
        this.buttonTimerNew = null;
      }
      this.timeNew = 60;
      this.sending = false;
      this.sendingNew = false;
      this.codeType = "";
      this.loading = false;
    },
    sendCode(type) {
      this.codeType = type;
      if (type === "new") {
        // 新手机-校验手机号
        if (!this.form.new_mobile) {
          this.$message.error("请输入手机号");
          return;
        }
        if (
          this.form.new_mobile.length < 6 ||
          this.form.new_mobile.length > 11
        ) {
          this.$message.warning("手机号格式错误！");
          return false;
        }
        // 校验是否存在
        checkAccount({ account: this.form.new_mobile }).then((res) => {
          if (res.code === 1) {
            this.showCaptcha();
          } else if (res.code === 20008) {
            this.$message.warning(
              "该手机号已经占用，请使用未绑定的手机号进行替换"
            );
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        // 发送验证码前需要人机验证
        this.showCaptcha();
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    codeList() {
      return this.$store.state.user.areaCodeList || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.content-wrap {
  .el-form .el-form-item {
    width: 450px;
  }
  .el-form .mobile-item {
    ::v-deep .el-form-item__content {
      display: flex;
    }

    .mobile {
      width: 200px;
      margin-right: 30px;
    }
  }
  .new-mobile-wrap {
    margin-top: 50px;
    .mobile ::v-deep {
      width: 300px !important;
      .login-mobile-input {
        border-radius: 4px;
      }
    }
  }
}
</style>
